import { XObjectType, X_OBJECT_TYPE } from '../../../../../globals';
import { IsNever, SchemaTypeName } from '../../../primitives';
import { NestedSchema, RootSchema } from '../../../union';
import { ISchemaRecord, ISchemaRecordProperties } from './record.types';

export * from './record.types';

/**  Types  */
type ISchemaRecordInput<PatternProperties extends ISchemaRecordProperties> = Omit<
    ISchemaRecord<PatternProperties>,
    'type' | 'const' | 'enum' | 'x-object-type'
>;

/**
 * Property value is an record or array of records
 * - Supports extraction of schema type from OneOfNullable<>
 * - No const, no enum
 */
export function record<PatternProperties extends ISchemaRecordProperties>(
    schema: RootSchema<ISchemaRecordInput<PatternProperties>>
): RootSchema<ISchemaRecord<PatternProperties>>;
export function record<PatternProperties extends ISchemaRecordProperties>(
    schema: ISchemaRecordInput<PatternProperties>
): NestedSchema<ISchemaRecord<PatternProperties>>;
export function record<PatternProperties extends ISchemaRecordProperties>(
    schema: ISchemaRecordInput<PatternProperties>
): ISchemaRecord<PatternProperties> {
    return {
        [X_OBJECT_TYPE]: XObjectType.RECORD,
        ...schema,
        type: SchemaTypeName.object,
    };
}

/**
 * Validation
 */

//  Confirm that the type of any key is `string`
const b1 = record({
    description: '',
    additionalProperties: false,
    patternProperties: {},
    $id: 'hello',
    title: '',
}).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = record({
    description: '',
    additionalProperties: false,
    patternProperties: {},
}).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
